import { Text } from 'pixi.js';

import { Game } from '../game/Game';
import { Widget } from './Widget';

export class PositionDisplayWidget extends Widget
{
    public game: Game;
    private positionLabel!: Text;
    private totalLabel!: Text;
    private dividerLabel!: Text;

    constructor(game: Game)
    {
        super();
        this.game = game;
    }

    protected async build(): Promise<void>
    {
        this.positionLabel = new Text(`1`, {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            stroke: 0x333333,
            strokeThickness: 11,
            lineJoin: 'round',
            align: 'right',
            fontSize: 80,
        });
        this.positionLabel.anchor.set(1, 0.5);
        this.view.addChild(this.positionLabel);

        this.dividerLabel = new Text(`/`, {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            stroke: 0x333333,
            strokeThickness: 11,
            lineJoin: 'round',
            align: 'center',
            fontSize: 56,
        });
        this.dividerLabel.anchor.set(0.5, 0.5);
        this.view.addChild(this.dividerLabel);

        this.totalLabel = new Text(`6`, {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            stroke: 0x333333,
            strokeThickness: 11,
            lineJoin: 'round',
            align: 'left',
            fontSize: 56,
        });
        this.totalLabel.anchor.set(0, 0.5);

        this.view.addChild(this.totalLabel);
    }

    public refresh(position: number, total: number): void
    {
        this.positionLabel.text = String(position);
        this.dividerLabel.text = '/';
        this.totalLabel.text = `${total}`;

        this.positionLabel.x = this.dividerLabel.x - (this.dividerLabel.width * 0.35);
        this.positionLabel.y = this.dividerLabel.y;

        this.totalLabel.x = this.dividerLabel.x + (this.dividerLabel.width * 0.2);
        this.totalLabel.y = this.dividerLabel.y + 10;
    }
}
